// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__ZX6C9","placeHolderShimmer":"ReportFilter_placeHolderShimmer__g6GBQ"};